module.exports = __webpack_public_path__ + "static/media/logout-success@2x.fa37f.png";